import "../DownloadNew/DownloadNew.css";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Pagination } from "antd";

import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import URLstateContext from "../../../provider/CommonContext";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import { format, parseISO } from "date-fns";
import Download_share from "../../../images/downlodes_share.webp";
import DownloadBanner from "../DownloadBanner/DownloadBanner";
import { useParams } from "react-router-dom";
import animation from "../../../images/jm-animation.gif";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { trackEvent, trackPageView } from "../../utils/tracking";

// NEW: 404 fallback rendered when the /downloads/... URL doesn't
// correspond to a real category / sub-category.
import NotFound from "../../NotFound/NotFound";

// NEW: whitelist mirrors the `case` labels in the switch below. Any
// 2-segment URL (/downloads/:category) whose slug isn't in this list
// is invalid.
const VALID_CATEGORY_SLUGS = [
  "scheme-financials",
  "portfolio-disclosure",
  "statutory-disclosure",
  "other-disclosure",
  "scheme-related-documents",
  "notice-and-addendums",
  "factsheet",
  "nfo",
  "forms",
  "product-literature",
  "portfolio",
  "others",
  "investor-awareness-program",
];

function DownloadNew() {
  const { CategeryId } = useParams();
  const { BaseURL } = useContext(URLstateContext);
  const [data, setData] = useState([]);
  const [dataDrop, setDataDrop] = useState([]);
  const [datadropsub, setDataDropsub] = useState([]);
  const [value, setValue] = React.useState(5);
  const [catId, setCatId] = useState("0");
  const [schemeDownload, setSchemeDownload] = useState("");
  const [SearchData, setSearchData] = useState([]);
  const [SearchText, setSearchText] = useState("");
  const [subcatId, setSubCatId] = useState("37");
  const socialIconsRef = useRef(null);
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const [jsonData, setJsonData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setselectedYear] = useState("");
  const [selectedFileType, setSelectedFileType] = useState("");
  const [currentPopupId, setCurrentPopupId] = useState("");
  const [CategoryIdUrl, SetCategoryIdUrl] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingshow, setLoadingshow] = useState(false);
  const [pathname, setPathName] = useState("");
  const [current, setCurrent] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const [size, setSize] = useState(perPage);

  // NEW: drives the 404 fallback.
  const [notFound, setNotFound] = useState(false);

  let categoryIdNew,
    subCategoryIdNew,
    categoryNameNew,
    subCategoryNameNew,
    dataNew;
  const { fontSize, changeFontSize, resetFontSize, changeFontSizeMinus } =
    useContext(URLstateContext);
  const navigate = useNavigate();

  useEffect(() => {
    const pathname = window.location.pathname;
    const segments = pathname
      .split("/")
      .filter((segment) => segment.trim() !== "");

    if (segments.length === 1) {
      // Plain "/downloads" — the default landing view, not an error.
      setNotFound(false);
    } else if (segments.length === 2) {
      // Only category slug is present in the URL: /downloads/:category
      const CategoryIdUrlid = segments[1];
      setPathName(CategoryIdUrlid);
      const slug = CategoryIdUrlid.toLowerCase();

      // NEW: reject unknown category slugs up front.
      if (!VALID_CATEGORY_SLUGS.includes(slug)) {
        setNotFound(true);
        return;
      }
      setNotFound(false);

      switch (slug) {
        case "scheme-financials":
          SetCategoryIdUrl("Scheme Financials");
          setCatId("1");
          setSubCatId("0");
          break;
        case "portfolio-disclosure":
          SetCategoryIdUrl("Portfolio Disclosure");
          setCatId("2");
          setSubCatId("0");
          break;
        case "statutory-disclosure":
          SetCategoryIdUrl("Statutory Disclosure");
          setCatId("3");
          setSubCatId("0");
          break;
        case "other-disclosure":
          SetCategoryIdUrl("Other disclosure");
          setCatId("4");
          setSubCatId("0");
          break;
        case "scheme-related-documents":
          SetCategoryIdUrl("Scheme related documents");
          setCatId("5");
          setSubCatId("0");
          break;
        case "notice-and-addendums":
          SetCategoryIdUrl("Notice and Addendums");
          setCatId("6");
          setSubCatId("0");
          break;
        case "factsheet":
          SetCategoryIdUrl("Factsheet");
          setCatId("10");
          setSubCatId("0");
          break;
        case "nfo":
          SetCategoryIdUrl("NFO");
          setCatId("20");
          setSubCatId("0");
          break;
        case "forms":
          SetCategoryIdUrl("Forms");
          setCatId("7");
          setSubCatId("0");
          break;
        case "product-literature":
          SetCategoryIdUrl("Product Literature");
          setCatId("14");
          setSubCatId("0");
          break;
        case "portfolio":
          SetCategoryIdUrl("Portfolio");
          setCatId("8");
          setSubCatId("0");
          break;
        case "others":
          SetCategoryIdUrl("Others");
          setCatId("9");
          setSubCatId("0");
          break;
        case "investor-awareness-program":
          SetCategoryIdUrl("Investor Awareness Program");
          setCatId("18");
          setSubCatId("0");
          break;
        default:
          // unreachable now thanks to the whitelist guard above,
          // kept only as a safety net.
          setNotFound(true);
          break;
      }
    } else if (segments.length === 3) {
      // /downloads/:category/:subcategory
      const CategoryName = decodeURIComponent(segments[1]).replace(/-/g, " ");
      let SubCategoryName = decodeURIComponent(segments[2]);

      if (segments[1].toLowerCase() === "forms") {
        SubCategoryName = SubCategoryName
          .replace(/-Forms$/i, " Forms")
          .replace("Non-Transactional", "Non-Transactional");
      } else {
        SubCategoryName = SubCategoryName.replace(/-/g, " ");
      }

      // NEW: normalizes away case/space/hyphen differences so
      // "Redemption Forms" and "redemption-forms" compare equal.
      const normalize = (s) =>
        (s || "").toString().toLowerCase().replace(/[\s-]/g, "");

      GetPostMethodData(BaseURL + "GetDownloadNewSub", {
        IVSubCategoryName: SubCategoryName,
      })
        .then((data) => {
          if (data.data != null && data.data.length > 0) {
            const decryptedData = DecryptAESdata(data.data);

            const categoryIdNew = decryptedData[0]?.DownloadCategoryID;
            const subCategoryIdNew = decryptedData[0]?.DownloadSubCategoryID;
            const returnedSubCategoryName =
              decryptedData[0]?.SubCategoryName;

            // NEW: don't just trust that the API returned *a* row —
            // confirm it's the row for the slug that was actually
            // requested. A backend doing a fuzzy/contains match can
            // return an unrelated real sub-category for garbage input
            // (e.g. /downloads/Forms/hdfvjshdfs), which the old
            // "does an ID exist" check couldn't catch.
            const isRealMatch =
              categoryIdNew &&
              subCategoryIdNew &&
              normalize(returnedSubCategoryName) === normalize(SubCategoryName);

            if (!isRealMatch) {
              setNotFound(true);
              return;
            }

            setNotFound(false);
            SetCategoryIdUrl(CategoryName);
            setSchemeDownload(SubCategoryName);
            setCatId(categoryIdNew);
            setSubCatId(subCategoryIdNew);

            GetPostMethodData(BaseURL + "GetDownloadNew", {
              IICategoryID: categoryIdNew,
              IISubCategoryID: subCategoryIdNew,
              IVsearch: SearchText,
            }).then((data) => {
              if (data.data != null && data.data.length > 0) {
                setData(DecryptAESdata(data.data));
              }
            });
          } else {
            // No matching sub-category at all for this slug
            // (e.g. /downloads/Forms/kjdgfjkdgb) -> 404.
            setNotFound(true);
          }
        })
        .catch(() => {
          // NEW: a failed/errored request must not leave the old UI
          // sitting there silently — treat it as unresolved too.
          setNotFound(true);
        });
    } else {
      // 0 segments (shouldn't happen under /downloads/*) or more than
      // 3 segments -> not a real page.
      setNotFound(true);
    }
  }, [BaseURL, SearchText]);

  function extractDomainFromURL(url) {
    var parser = document.createElement("a");
    parser.href = url;
    return (
      parser.protocol +
      "//" +
      parser.hostname +
      (parser.port ? ":" + parser.port : "")
    );
  }

  const handleChangeCat = (event) => {
    setCurrent(1);
    setSelectedMonth("");
    setselectedYear("");
    setSelectedFileType("");
    event.preventDefault();
    setSubCatId("0");
    setCatId(event.target.value);
    navigate(
      `/downloads/${event.target.options[event.target.selectedIndex].text
        .replace(/ /g, "-")
        .replace("&", "and")
        .replace("+", "")}`
    );
  };

  const handleChangeSubCat = (event) => {
    setCurrent(1);
    setSubCatId(event.target.value);
    setselectedYear("");

    const selectDiv = document.getElementById("fund");
    const schemeDescSub = document.getElementById("fundSub");

    const catIdNew = selectDiv.options[selectDiv.selectedIndex].text;
    let subCatNew = schemeDescSub.options[schemeDescSub.selectedIndex].text;

    SetCategoryIdUrl(catIdNew);
    setSchemeDownload(subCatNew);

    subCatNew = subCatNew.replace(/\//g, "");

    const encodedCatId = encodeURIComponent(catIdNew)
      .replace(/%20/g, "-")
      .replace(/%26/g, "and");

    const encodedSubCat = encodeURIComponent(subCatNew)
      .replace(/%20/g, "-")
      .replace(/%26/g, "and");

    const updatedURL = `/downloads/${encodedCatId}/${encodedSubCat}`;

    navigate(updatedURL);
  };

  useEffect(() => {
    document.getElementById("searchtext").style.display = "none";
    document.getElementById("SearchData").style.display = "none";
    if (catId === "7") {
      document.getElementById("yearsdrop").style.display = "none";
      document.getElementById("yearsdroplab").style.display = "none";
      document.getElementById("searchtext").style.display = "none";
      document.getElementById("SearchData").style.display = "none";
    } else {
      document.getElementById("yearsdrop").style.display = "block";
      document.getElementById("yearsdroplab").style.display = "block";
      document.getElementById("searchtext").style.display = "none";
      document.getElementById("SearchData").style.display = "none";
    }
    setLoadingshow(true);

    if (catId !== "") {
      GetPostMethodData(BaseURL + "GetDownloadNew", {
        IICategoryID: catId,
        IISubCategoryID: subcatId,
        IVsearch: SearchText,
      }).then((data) => {
        setLoadingshow(false);
        if (data.data != null && data.data.length > 0) {
          setData(DecryptAESdata(data.data));
          setLoadingshow(false);
          if (SearchText != "" && SearchText.length >= 3) {
            setSearchData(DecryptAESdata(data.data));
            setJsonData(DecryptAESdata(data.data));
            document.getElementById("searchtext").style.display = "block";
            document.getElementById("SearchData").style.display = "block";
            filterData();
            setLoadingshow(false);
          } else {
            document.getElementById("searchtext").style.display = "none";
            document.getElementById("SearchData").style.display = "none";
          }
        } else {
          setData([]);
          if (SearchText != "" && SearchText.length >= 3) {
            setSearchData(null);
            document.getElementById("searchtext").style.display = "block";
            document.getElementById("SearchData").style.display = "block";
          }
          setLoadingshow(false);
        }
      });
    }
  }, [BaseURL, catId, subcatId, SearchText]);

  useEffect(() => {
    if (!catId || catId === "0") {
      if (SearchText === "") {
        document.getElementById("searchtext").style.display = "none";
        document.getElementById("SearchData").style.display = "none";
      }
    }
    GetPostMethodData(BaseURL + "GetDownloadDrop", {
      IICategoryID: "0",
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDrop(DecryptAESdata(data.data));
      }
    });
    GetPostMethodData(BaseURL + "GetDownloadDrop", {
      IICategoryID: catId,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setDataDropsub(DecryptAESdata(data.data));
      }
    });
  }, [BaseURL, catId]);

  const handleShareButtonClick = (e) => {
    const fetchId = e.currentTarget.getAttribute("data-id");
    const popupId = "d_" + fetchId.split("_")[1];
    const popup = document.getElementById(popupId);
    const isSamePopup = currentPopupId === popupId;

    if (currentPopupId) {
      const currentPopup = document.getElementById(currentPopupId);
      if (currentPopup) {
        currentPopup.style.display = isSamePopup ? "none" : "none";
      }
    }

    if (!isSamePopup) {
      popup.style.display = "block";
      setCurrentPopupId(popupId);
    } else {
      setCurrentPopupId(null);
    }

    setIsLinkCopied(false);
  };

  const handleEmailClick = (e) => {
    const blgURL = e.currentTarget.getAttribute("data-head");
    const subject = "Check out this amazing website!";
    const body =
      "Hi,\n\nI found this awesome website that I think you'll love! Check it out:" +
      `${blgURL}`;
    const recipientInput = window.prompt(
      "Enter recipient email addresses (comma-separated):"
    );

    if (recipientInput) {
      const recipients = recipientInput.split(",").map((email) => email.trim());
      const to = recipients.join(",");
      const mailtoURL = `mailto:${to}?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoURL;
    }
  };

  const downloadPDF = async (e) => {
    const BaseURL1 = e.currentTarget.getAttribute("data-head");
    const BaseURL = BaseURL1;
    const fileName = BaseURL.split("/").pop();
    try {
      const response = await fetch(BaseURL);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const tempAnchor = document.createElement("a");
      tempAnchor.href = url;
      tempAnchor.download = fileName;
      document.body.appendChild(tempAnchor);
      tempAnchor.click();
      document.body.removeChild(tempAnchor);
      URL.revokeObjectURL(url);
    } catch (error) {}
  };

  const downloadPDFDrop = async (e) => {
    const BaseURL1 = e.currentTarget.getAttribute("data-head");
    const BaseURL = BaseURL1;
    const fileName = BaseURL1.split("/")[3];
    try {
      const response = await fetch(BaseURL);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const tempAnchor = document.createElement("a");
      tempAnchor.href = url;
      tempAnchor.download = fileName;
      document.body.appendChild(tempAnchor);
      tempAnchor.click();
      document.body.removeChild(tempAnchor);
      URL.revokeObjectURL(url);
      document.getElementById("searchtext").style.display = "none";
      document.getElementById("SearchData").style.display = "none";
    } catch (error) {}
  };

  const handleCopyClick = (e) => {
    const blgURL = e.currentTarget.getAttribute("data-head");
    const linkToCopy = blgURL;
    const inputElement = document.createElement("input");
    inputElement.value = linkToCopy;
    document.body.appendChild(inputElement);
    inputElement.select();
    document.execCommand("copy");
    document.body.removeChild(inputElement);
    setIsLinkCopied(true);
  };

  let DataFilter = [];

  function getDistinctValuesAsDict(list, key) {
    const distinctValuesSet = new Set(list.map((dict) => dict[key]));
    return Array.from(distinctValuesSet).map((value) => ({ [key]: value }));
  }

  function getDistinctYears(data) {
    const distinctYearsSet = new Set(
      data.map((item) => new Date(item.DocumentDate).getFullYear())
    );
    let yearsFinal = Array.from(distinctYearsSet);
    let startYear = yearsFinal[0];

    if (startYear !== undefined) {
      yearsFinal.unshift(startYear + 1);
      return yearsFinal;
    }

    return yearsFinal;
  }

  const handleMonthChange = (event) => {
    setSelectedMonth(event.target.value);
    setCurrent(1);
  };
  const handleYearChange = (event) => {
    setselectedYear(event.target.value);
    setCurrent(1);
  };

  const handleFileTypeChange = (event) => {
    setSelectedFileType(event.target.value);
    setCurrent(1);
  };
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    if (currentMonth < 3) {
      return `${currentYear - 1} - ${currentYear}`;
    } else {
      return `${currentYear} - ${currentYear + 1}`;
    }
  };

  const filterData = (data, selectedMonth, selectedYear, selectedFileType) => {
    return (
      data &&
      data.filter((item) => {
        const documentDate = new Date(item.DocumentDate);
        if (selectedYear === "") {
          return selectedFileType === "" || item.FileEXT === selectedFileType;
        }
        const selectedYearValue = parseInt(selectedYear, 10);
        const fileTypeCondition =
          selectedFileType === "" || item.FileEXT === selectedFileType;
        const otherFiscalYearStart = new Date(selectedYearValue - 1, 3, 1);
        const otherFiscalYearEnd = new Date(selectedYearValue, 2, 31);
        const isDataInOtherYear =
          documentDate >= otherFiscalYearStart &&
          documentDate <= otherFiscalYearEnd;
        return isDataInOtherYear && fileTypeCondition;
      })
    );
  };

  function isDataInPreviousYear(selectedYearValue, documentDate) {
    const year1Start = new Date(selectedYearValue - 1, 3, 1);
    const year1End = new Date(selectedYearValue, 2, 31);
    return documentDate >= year1Start && documentDate <= year1End;
  }

  const filteredData = useMemo(() => {
    return filterData(data, selectedMonth, selectedYear, selectedFileType);
  }, [data, selectedMonth, selectedYear, selectedFileType]);

  function handleInputChange(event) {
    document.getElementById("searchtext").style.display = "block";
    let Blogdata = event.target.value;
    if (Blogdata.length >= 3) {
      setSearchText(Blogdata);
    } else {
      DataFilter = [];
      setSearchText("");
      setSearchData(DataFilter);

      if (SearchData === "") {
        document.getElementById("searchtext").style.display = "none";
      }
    }
  }

  let schemeDesc = document.getElementById("fund");
  let schemeDescSub = document.getElementById("fundSub");

  let PageSize = size;

  const PaginationChange = (page, pageSize) => {
    setCurrent(page);
    setSize(pageSize);
  };

  const currentTableData = useMemo(() => {
    if (filteredData != null && filteredData.length > 0) {
      const firstPageIndex = (current - 1) * PageSize;
      const lastPageIndex = firstPageIndex + PageSize;
      return filteredData.slice(firstPageIndex, lastPageIndex);
    }
    return [];
  }, [current, PageSize, filteredData, SearchData]);

  const itemRender = (page, type, originalElement) => {
    switch (type) {
      case "prev":
        return (
          <button
            type="button"
            className="pagination-arrow"
            aria-label="Go to previous page"
          >
            <i className="fa fa-angle-double-left" aria-hidden="true"></i>
          </button>
        );

      case "next":
        return (
          <button
            type="button"
            className="pagination-arrow"
            aria-label="Go to next page"
          >
            <i className="fa fa-angle-double-right" aria-hidden="true"></i>
          </button>
        );

      default:
        return originalElement;
    }
  };

  // NEW: bail out to the 404 page before rendering any of the normal
  // downloads UI. This runs after all hooks above, so hook order is
  // unaffected.
  if (notFound) {
    return <NotFound />;
  }

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <meta charset="UTF-8" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta
            name="description"
            content="Download the latest monthly factsheets for JM Financial Mutual Fund schemes. Stay informed about NAVs, portfolio details, and performance metrics for better decision-making."
          />
          <title>
            Monthly Factsheet Download | Access Latest Fund Performance Data |
            JM Financial Mutual Fund
          </title>
        </Helmet>
      </HelmetProvider>

      <DownloadBanner />
      <main
        className="downlodes-main"
        style={{ fontSize: `${fontSize}px` }}
        id="main-content"
        tabIndex="-1"
      >
        <section className="downlodes_banner-sc">
          <Container>
            <Row>
              <Col sm={12}>
                <div className="form-group-container">
                  <div className="form-group search-input">
                    <input
                      type="text"
                      name="SearchBlogs"
                      onChange={handleInputChange}
                      id="SearchBlogs"
                      aria-label="Search downloads"
                      placeholder="What Are You Looking To Download..."
                      autoComplete="off"
                    />
                    <div className="icon-container" id="searchtext">
                      <div className="downloades_input-search-container">
                        <div
                          role="status"
                          aria-live="polite"
                          aria-atomic="true"
                          className="sr-only"
                        >
                          {SearchData?.length === 0
                            ? "No data found"
                            : `${SearchData?.length || 0} results found`}
                        </div>
                        {SearchData && SearchData.length > 0 ? (
                          <>
                            <div
                              className="downloades_input-search"
                              id="SearchData"
                            >
                              <ul>
                                <li className="font-bold-category">Category</li>
                                <li className="font-bold-category">
                                  Sub Category
                                </li>
                                <li className="font-bold-category">Title</li>
                              </ul>
                              {SearchData &&
                                SearchData.map(
                                  ({
                                    CategoryName,
                                    FileName,
                                    SubCategoryName,
                                    Title,
                                  }) => (
                                    <ul className="search-ul">
                                      <li>
                                        <a>{CategoryName}</a>
                                      </li>
                                      <li>
                                        <a>{SubCategoryName}</a>
                                      </li>
                                      <li>
                                        <a
                                          data-head={FileName}
                                          onClick={downloadPDFDrop}
                                        >
                                          {Title}
                                        </a>
                                      </li>
                                    </ul>
                                  ),
                                )}
                            </div>
                          </>
                        ) : (
                          <div
                            className="downloades_input-search no_data_search"
                            id="SearchData"
                          >
                            <p>No Data Found !!!</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group-container">
                  <div className="form-group">
                    <div className="selects-containers">
                      <div className="select-container">
                        <label htmlFor="category-select" className="sr-only">
                          Select category
                        </label>
                        <select
                          name="fund"
                          id="category-select"
                          className="fund-selector"
                          onChange={handleChangeCat}
                          autoComplete="off"
                        >
                          <option value="0">Select Category</option>
                          {dataDrop &&
                            dataDrop.map(
                              ({ DownloadCategoryID, CategoryName }) => (
                                <option
                                  value={DownloadCategoryID}
                                  selected={CategoryIdUrl === CategoryName}
                                >
                                  {CategoryName}
                                </option>
                              ),
                            )}
                        </select>
                        <i className="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                      <div className="select-container">
                        <label htmlFor="subcategory-select" className="sr-only">
                          Select sub category
                        </label>
                        {catId === "0" ? (
                          <select
                            name="fund"
                            id="subcategory-select"
                            className="fund-selector"
                            autoComplete="off"
                            disabled
                          >
                            <option value="">Select Sub Category</option>
                          </select>
                        ) : (
                          <select
                            name="fund"
                            id="subcategory-select"
                            className="fund-selector"
                            onChange={handleChangeSubCat}
                            autoComplete="off"
                          >
                            <option value="0">Select Sub Category</option>
                            {datadropsub &&
                              datadropsub.map(
                                ({
                                  DownloadSubCategoryID,
                                  SubCategoryName,
                                }) => (
                                  <option
                                    value={DownloadSubCategoryID}
                                    selected={
                                      schemeDownload === SubCategoryName
                                    }
                                  >
                                    {SubCategoryName}
                                  </option>
                                ),
                              )}
                          </select>
                        )}
                        <i className="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
          <div></div>
        </section>

        <section className="downlodes_application-form-sc">
          <Container>
            <Row>
              <Col>
                <nav aria-label="Breadcrumb">
                  <ul className="navigator-arrow">
                    <li>
                      <a href="/" aria-label="Home">
                        <i class="fa fa-home" aria-hidden="true"></i>
                      </a>{" "}
                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </li>
                    <li>
                      <a href="/downloads">
                        <span>Downloads</span>
                      </a>{" "}
                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </li>
                    <li>
                      {schemeDesc != null && schemeDesc != undefined
                        ? schemeDesc.options[schemeDesc.selectedIndex].text !=
                          "Select Category"
                          ? schemeDesc.options[schemeDesc.selectedIndex].text
                          : ""
                        : ""}
                    </li>
                  </ul>
                </nav>
              </Col>
            </Row>
          </Container>

          <Container>
            <Row>
              <Col sm={12}>
                <div className="downlode-container">
                  <div className="select-bar">
                    <p className="fin-year p-1 p-md-0 fs-6" id="yearsdroplab">
                      FY{" "}
                    </p>
                    <div className="select-container" id="yearsdrop">
                      <label
                        htmlFor="financial-year-select"
                        className="sr-only"
                      >
                        Financial Year
                      </label>

                      <select
                        name="fund"
                        id="financial-year-select"
                        className="data-selector"
                        value={selectedYear}
                        onChange={handleYearChange}
                        autoComplete="off"
                      >
                        <option value="">All Year</option>
                        {data &&
                          getDistinctYears(data).map((year) => (
                            <option key={year} value={year}>
                              {year - 1} - {year}
                            </option>
                          ))}
                      </select>
                    </div>

                    {catId === "5" && subcatId === "30" ? (
                      <div className="select-container">
                        <select
                          className="data-selector"
                          value={selectedFileType}
                          onChange={handleFileTypeChange}
                          autoComplete="off"
                        >
                          <option value="">All File Types</option>
                          {data &&
                            getDistinctValuesAsDict(data, "FileEXT").map(
                              ({ FileEXT }) => (
                                <option value={FileEXT}>{FileEXT}</option>
                              ),
                            )}
                        </select>

                        <i className="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>

                  {catId === "0" ? (
                    <div className="textCenter"></div>
                  ) : (
                    <>
                      {data != [] ? (
                        ""
                      ) : (
                        <div className="errormsgComNew" role="alert">
                          <p>No Data Found</p>
                        </div>
                      )}
                      {currentTableData &&
                        currentTableData.map(
                          ({
                            CategoryID,
                            CategoryName,
                            DocumentDate,
                            DownloadID,
                            FileEXT,
                            FileName,
                            SubCategoryName,
                            Title,
                          }) => (
                            <div className="downlode-box">
                              <div className="">
                                <p className="date">
                                  {DocumentDate != null
                                    ? format(
                                        parseISO(DocumentDate),
                                        "dd-MMM-yyyy",
                                      )
                                    : ""}
                                </p>
                                <p>{Title}</p>
                              </div>
                              <ul>
                                <li>
                                  <a
                                    rel="noreferrer"
                                    href={FileName}
                                    target="blank"
                                    aria-label={`View ${Title} (${DocumentDate ? format(parseISO(DocumentDate), "dd-MMM-yyyy") : ""})`}
                                  >
                                    View
                                  </a>
                                </li>
                                <li>
                                  <button
                                    type="button"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="share-btn"
                                    data-head={FileName}
                                    onClick={downloadPDF}
                                    aria-label={`Download ${Title}`}
                                  >
                                    Download
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className="share-btn"
                                    type="button"
                                    id={`shareButton-${DownloadID}`}
                                    data-id={"s_" + DownloadID}
                                    onClick={handleShareButtonClick}
                                    aria-label={`Share ${Title} document`}
                                  >
                                    <img
                                      src={Download_share}
                                      alt=""
                                      aria-hidden="true"
                                    />
                                  </button>
                                </li>
                                <li>
                                  <div
                                    className="social-icons-download"
                                    id={"d_" + DownloadID}
                                    ref={socialIconsRef}
                                  >
                                    <button
                                      onClick={handleEmailClick}
                                      type="button"
                                      className="icon"
                                      aria-label="Share via email"
                                    >
                                      <i
                                        className="fa fa-envelope"
                                        aria-hidden="true"
                                        data-head={
                                          extractDomainFromURL(
                                            window.location.url,
                                          ) +
                                          "/" +
                                          FileName
                                        }
                                      ></i>
                                    </button>
                                    <div>
                                      <button
                                        onClick={handleCopyClick}
                                        type="button"
                                        className="icon"
                                        aria-label={
                                          isLinkCopied
                                            ? "Link copied"
                                            : "Copy link"
                                        }
                                      >
                                        {isLinkCopied ? (
                                          <span>Copied</span>
                                        ) : (
                                          <i
                                            className="fa fa-link"
                                            aria-hidden="true"
                                            data-head={
                                              extractDomainFromURL(
                                                window.location.url,
                                              ) +
                                              "/" +
                                              FileName
                                            }
                                          ></i>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          ),
                        )}
                      {loadingshow ? (
                        <div
                          className="textcentervertex"
                          role="status"
                          aria-live="polite"
                          aria-busy="true"
                        >
                          <img src={animation} alt="" aria-hidden="true" />
                          <div className="model_popup">Please Wait...</div>
                        </div>
                      ) : (
                        ""
                      )}

                      {currentTableData.length > 0 && (
                        <Pagination
                          align="end"
                          className="pagination-data"
                          current={current}
                          pageSize={size}
                          total={filteredData?.length || 0}
                          onChange={PaginationChange}
                          showSizeChanger={false}
                          showTitle={false}
                          itemRender={itemRender}
                        />
                      )}
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </main>
    </>
  );
}

export default DownloadNew;